import System, {
    // PElement,
    IElement,
    DElement,
    TtElement,
    T1Element,
    PT1Element,
    // IT1Element,
    // DT1Element,
    I2Element,
    // PT1TtElement,
    // Hysteresis,
} from './systems';

// --------------------------------------------------------------------------------

export class LowPass extends T1Element {

    // identical with T1Element

    static getName(){
        return 'LowPass';
    }

}

// --------------------------------------------------------------------------------

export class DeadTime extends TtElement {

    // identical with TtElement

    static getName(){
        return 'DeadTime';
    }

}

// --------------------------------------------------------------------------------

export class Integrator extends IElement {

    static getName(){
        return 'Integrator';
    }

}

// --------------------------------------------------------------------------------

export class Differentiator extends DElement {

    static getName(){
        return 'Differentiator';
    }

}

// --------------------------------------------------------------------------------

export class LowPassWithDeadTime extends System {

    constructor(parameters) {
        super();
        this.t1element = new T1Element({t_1: parameters.t_1 !== undefined ? parameters.t_1 : 1});
        this.ttelement = new TtElement({t_t: parameters.t_t !== undefined ? parameters.t_t : 0.1});
    }

    updateParameters(parameters) {
        this.t1element.updateParameters(parameters);
        this.ttelement.updateParameters(parameters);
    }

    getNextValues(x) {
        this.y_last = this.t1element.getNextValues(this.ttelement.getNextValues(x).y).y;
        return {y: this.y_last};
    }

    reset() {
        this.t1element.reset();
        this.ttelement.reset();
    }

    static getName() {
        return 'LowPassWithDeadTime';
    }

}

// --------------------------------------------------------------------------------

export class DoubleIntegrator extends I2Element {

    static getName() {
        return 'DoubleIntegrator';
    }

}

// --------------------------------------------------------------------------------

export class SolderingIron extends System {

    static unitT = 's';
    static unitY = '°C';
    static unitE = 'K';
    static unitU = 'V';
    static axisTitleControlled = 'actual_temperature';
    static axisTitleControlledAndReference = 'target_and_actual_temperature';
    static axisTitleActuating = 'input_voltage';
    static axisTitleControlDeviation = 'temperature_deviation';
    static u_max = 230;
    static u_min = 0;

    constructor() {
        super();
        this.pt1element = new PT1Element({t_1: 30, k_p: 600/230});
        this.ambientTemp = 20;
        this.unitT = 's';
    }

    getNextValues(x) {
        this.y_last = this.pt1element.getNextValues(x).y + this.ambientTemp;
        return {y: this.y_last};
    }

    reset() {
        this.pt1element.reset();
    }

    static getName() {
        return 'SolderingIron';
    }

}

// --------------------------------------------------------------------------------

export class BakingOven extends System {

    static unitT = 'min';
    static unitY = '°C';
    static unitE = 'K';
    static unitU = 'V';
    static axisTitleControlled = 'actual_temperature';
    static axisTitleControlledAndReference = 'target_and_actual_temperature';
    static axisTitleActuating = 'input_voltage';
    static axisTitleControlDeviation = 'temperature_deviation';
    static u_max = 230;
    static u_min = 0;

    constructor() {
        super();
        this.pt1element = new PT1Element({t_1: 8, k_p: 400/230});
        this.ambientTemp = 20;
        this.factorSpeedUp = 10;
        this.unitT = 'min';
    }

    getNextValues(x) {
        this.y_last = this.pt1element.getNextValues(x).y + this.ambientTemp;
        return {y: this.y_last};
    }

    reset() {
        this.pt1element.reset();
    }

    static getName() {
        return 'BakingOven';
    }

}

// --------------------------------------------------------------------------------

export class Refrigerator extends System {

    static unitT = 'min';
    static unitY = '°C';
    static unitE = 'K';
    static unitU = 'V';
    static axisTitleControlled = 'actual_temperature';
    static axisTitleControlledAndReference = 'target_and_actual_temperature';
    static axisTitleActuating = 'input_voltage';
    static axisTitleControlDeviation = 'temperature_deviation';
    static u_max = 230;
    static u_min = 0;

    constructor() {
        super();
        this.pt1element = new PT1Element({t_1: 20, k_p: -30/230});
        this.ambientTemp = 20;
        this.factorSpeedUp = 10;
        this.unitT = 'min';
    }

    getNextValues(x) {
        this.y_last = this.pt1element.getNextValues(x).y + this.ambientTemp;
        return {y: this.y_last};
    }

    reset() {
        this.pt1element.reset();
    }

    static getName() {
        return 'Refrigerator';
    }

}

// --------------------------------------------------------------------------------

export class Freezer extends System {

    static unitT = 'min';
    static unitY = '°C';
    static unitE = 'K';
    static unitU = 'V';
    static axisTitleControlled = 'actual_temperature';
    static axisTitleControlledAndReference = 'target_and_actual_temperature';
    static axisTitleActuating = 'input_voltage';
    static axisTitleControlDeviation = 'temperature_deviation';
    static u_max = 230;
    static u_min = 0;

    constructor() {
        super();
        this.pt1element = new PT1Element({t_1: 20, k_p: -60/230});
        this.ambientTemp = 20;
        this.factorSpeedUp = 10;
        this.unitT = 'min';
    }

    getNextValues(x) {
        this.y_last = this.pt1element.getNextValues(x).y + this.ambientTemp;
        return {y: this.y_last};
    }

    reset() {
        this.pt1element.reset();
    }

    static getName() {
        return 'Freezer';
    }

}

// --------------------------------------------------------------------------------

export class ClothesIron extends System {

    static unitT = 'min';
    static unitY = '°C';
    static unitE = 'K';
    static unitU = 'V';
    static axisTitleControlled = 'actual_temperature';
    static axisTitleControlledAndReference = 'target_and_actual_temperature';
    static axisTitleActuating = 'input_voltage';
    static axisTitleControlDeviation = 'temperature_deviation';
    static u_max = 230;
    static u_min = 0;

    constructor() {
        super();
        this.pt1element = new PT1Element({t_1: 20, k_p: 200/230});
        this.ambientTemp = 20;
        this.factorSpeedUp = 10;
        this.unitT = 'min';
    }

    getNextValues(x) {
        this.y_last = this.pt1element.getNextValues(x).y + this.ambientTemp;
        return {y: this.y_last};
    }

    reset() {
        this.pt1element.reset();
    }

    static getName() {
        return 'ClothesIron';
    }

}

// --------------------------------------------------------------------------------

export class Compressor extends System {

    static unitT = 's';
    static unitY = 'bar';
    static unitE = 'bar';
    static unitU = 'V';
    static axisTitleControlled = 'actual_pressure';
    static axisTitleControlledAndReference = 'target_and_actual_pressure';
    static axisTitleActuating = 'input_voltage';
    static axisTitleControlDeviation = 'pressure_deviation';
    static u_max = 230;
    static u_min = 0;

    constructor() {
        super();
        this.pt1element = new PT1Element({t_1: 10, k_p: 10/230});
        this.ambientPressure = 1;
        this.unitT = 's';
    }

    getNextValues(x) {
        this.y_last = this.pt1element.getNextValues(x).y + this.ambientPressure;
        return {y: this.y_last};
    }

    reset() {
        this.pt1element.reset();
    }

    static getName() {
        return 'Compressor';
    }

}

// --------------------------------------------------------------------------------

export class LiquidTank extends System {

    static unitT = 's';
    static unitY = 'cm';
    static unitE = 'cm';
    static unitU = 'V';
    static axisTitleControlled = 'actual_level';
    static axisTitleControlledAndReference = 'target_and_actual_level';
    static axisTitleActuating = 'input_voltage';
    static axisTitleControlDeviation = 'level_deviation';
    static u_max = 230;
    static u_min = -230;

    constructor() {
        super();
        this.ielement = new IElement({t_i: 230/5});
        this.ambientPressure = 1;
        this.unitT = 's';
    }

    getNextValues(x) {
        this.y_last = this.ielement.getNextValues(x).y;
        return {y: this.y_last};
    }

    reset() {
        this.ielement.reset();
    }

    static getName() {
        return 'LiquidTank';
    }

}

// --------------------------------------------------------------------------------

export class RacletteOven extends System {

    static unitT = 'min';
    static unitY = '°C';
    static unitE = 'K';
    static unitU = 'V';
    static axisTitleControlled = 'actual_temperature';
    static axisTitleControlledAndReference = 'target_and_actual_temperature';
    static axisTitleActuating = 'input_voltage';
    static axisTitleControlDeviation = 'temperature_deviation';
    static u_max = 230;
    static u_min = 0;

    constructor() {
        super();
        this.pt1element = new PT1Element({t_1: 8, k_p: 400/230});
        this.ambientTemp = 20;
        this.factorSpeedUp = 10;
        this.unitT = 'min';
    }

    getNextValues(x) {
        this.y_last = this.pt1element.getNextValues(x).y + this.ambientTemp;
        return {y: this.y_last};
    }

    reset() {
        this.pt1element.reset();
    }

    static getName() {
        return 'RacletteOven';
    }

}

// --------------------------------------------------------------------------------
